<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="caesarea-philippi-4453-c.e.">
<h1 style="padding-top:180px; font-family:Arial;">Caesarea Philippi (44–53 C.E.)</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?46eaa2a2